<!--
 * @Description: 数据表格，重写了scTable，做自定义设置
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2022-12-03 01:12:26
 * @LastEditors: Monkey
 * @LastEditTime: 2025-08-30 11:41:30
-->


<template>
  <div class="scTable alljoins-table" :style="{ 'height': _height }" ref="scTableMain" v-loading="loading">
    <div class="scTable-table" :style="{ 'height': _table_height }">
      <el-table v-bind="$attrs" :data="tableData" :row-key="rowKey" :key="toggleIndex" ref="scTable"
        :height="height == 'auto' ? null : '100%'" :size="config.size" :border="config.border" :stripe="config.stripe"
        :summary-method="remoteSummary ? remoteSummaryMethod : summaryMethod" @sort-change="sortChange"
        @filter-change="filterChange">

        <el-table-column v-if="isShowIndex" type="index" width="40" :fixed="ismobile ? false : 'left'" align="center"
          class-name="aj-table-column-index" />
        <el-table-column v-if="isSelection" type="selection" width="40" align="center" />

        <!-- 前置字段，有特殊定义的，不进行循环 -->
        <slot name="beforeColumn" />

        <template v-for="(item, index) in userColumn" :key="index">
          <el-table-column v-if="!item.hide" :column-key="item.prop" :label="item.label" :prop="item.prop"
            :width="item.width" :sortable="item.sortable" :fixed="item.fixed" :filters="item.filters"
            :align="item.align === undefined ? '' : item.align"
            :filter-method="remoteFilter || !item.filters ? null : filterHandler"
            :formatter="(row, col) => { return columnFormat(row, col, item.formatter) }"
            :class-name="item.className === undefined ? '' : item.className"
            :show-overflow-tooltip="item.showOverflowTooltip">
            <template v-if="item.customSlot" #default="scope">
              <slot :name="item.customSlot" :row="scope.row" />
            </template>
            <!-- 处理 tag 类型 -->
            <template v-else-if="item.template?.type === 'tag'" #default="scope">
              <el-tag :type="getTemplateAttrValue(item.template, 'type', scope.row) || 'info'"
                :closable="getTemplateAttrValue(item.template, 'closable', scope.row)"
                :disable-transitions="getTemplateAttrValue(item.template, 'disableTransitions', scope.row)"
                :hit="getTemplateAttrValue(item.template, 'hit', scope.row)"
                :color="getTemplateAttrValue(item.template, 'color', scope.row)"
                :size="getTemplateAttrValue(item.template, 'size', scope.row) || 'small'"
                :effect="getTemplateAttrValue(item.template, 'effect', scope.row) || 'light'"
                :round="getTemplateAttrValue(item.template, 'round', scope.row)" :class="item.client ? 'curpoint' : ''"
                @click="item.client && handleClientClick(item, scope.row)">
                {{ columnFormat(scope.row, scope.column, item.formatter) }}
              </el-tag>
            </template>
            <!-- 处理 switch 类型 -->
            <template v-else-if="item.template?.type === 'switch'" #default="scope">
              <el-switch v-model="scope.row[item.prop]"
                :loading="getTemplateAttrValue(item.template, 'loading', scope.row) || false"
                :active-value="item.template.attr?.activeValue" :inactive-value="item.template.attr?.inactiveValue"
                :size="getTemplateAttrValue(item.template, 'size', scope.row)"
                @change="(val) => item.template.function?.change ? item.template.function.change(scope.row[item.prop], scope.row, item) : null">
              </el-switch>
            </template>
            <!-- 处理 icon 类型 -->
            <template v-else-if="item.template?.type === 'icon'" #default="scope">
              <div style="display: flex; align-items: center;">
                <el-icon v-for="(attrValue, attrName) in item.template.attr" :key="attrName"
                  :class="item.client ? 'curpoint' : ''" @click="item.client && handleClientClick(item, scope.row)"
                  style="margin-bottom: 0">
                  <component :is="typeof attrValue === 'function' ? attrValue(scope.row) : attrValue"
                    v-if="attrName === 'type'" />
                </el-icon>
                <span v-if="item.formatter" style="margin-left: 2px">{{ columnFormat(scope.row, scope.column,
                  item.formatter) }}</span>
              </div>
            </template>
            <!-- 处理点击事件 -->
            <template v-else-if="item.client" #default="scope">
              <span class="client-cell curpoint" @click="handleClientClick(item, scope.row)">
                {{ columnFormat(scope.row, scope.column, item.formatter) }}
              </span>
            </template>
          </el-table-column>
        </template>

        <slot></slot>

        <el-table-column min-width="1"></el-table-column>
        <template #empty>
          <el-empty :description="emptyText" :image-size="100"></el-empty>
        </template>
      </el-table>
    </div>
    <div class="scTable-page" v-if="!hidePagination || !hideDo">
      <div class="scTable-pagination">
        <el-pagination v-if="!hidePagination" background size="small" :layout="paginationLayout" :total="total"
          :page-size="scPageSize" :page-sizes="pageSizes" v-model:currentPage="currentPage"
          @current-change="paginationChange" @update:page-size="pageSizeChange"></el-pagination>
      </div>
      <div class="scTable-do" v-if="!hideDo">
        <el-button v-if="!hideRefresh" @click="refresh" icon="el-icon-refresh" circle
          style="margin-left:15px"></el-button>
        <el-popover v-if="column" placement="top" title="列设置" :width="500" trigger="click" :hide-after="0"
          @show="customColumnShow = true" @after-leave="customColumnShow = false">
          <template #reference>
            <el-button icon="el-icon-set-up" circle style="margin-left:15px"></el-button>
          </template>
          <columnSetting v-if="customColumnShow" ref="columnSetting" @userChange="columnSettingChange"
            @save="columnSettingSave" @back="columnSettingBack" :column="userColumn"></columnSetting>
        </el-popover>
        <el-popover v-if="!hideSetting" placement="top" title="表格设置" :width="400" trigger="click" :hide-after="0">
          <template #reference>
            <el-button icon="el-icon-setting" circle style="margin-left:15px"></el-button>
          </template>
          <el-form label-width="80px" label-position="left">
            <el-form-item label="表格尺寸">
              <el-radio-group v-model="config.size" size="small" @change="configSizeChange">
                <el-radio-button value="large">大</el-radio-button>
                <el-radio-button value="default">正常</el-radio-button>
                <el-radio-button value="small">小</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="样式">
              <el-checkbox v-model="config.border" label="纵向边框" @change="configChange"></el-checkbox>
              <el-checkbox v-model="config.stripe" label="斑马纹" @change="configChange"></el-checkbox>
            </el-form-item>
          </el-form>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config/table";
import columnSetting from './columnSetting';

export default {
  name: 'scTable',
  components: {
    columnSetting
  },
  props: {
    tableName: { type: String, default: "" },
    apiObj: { type: Object, default: () => { } },
    params: { type: Object, default: () => ({}) },
    data: { type: Object, default: () => { } },
    height: { type: [String, Number], default: "100%" },
    size: { type: String, default: "default" },
    border: { type: Boolean, default: false },
    stripe: { type: Boolean, default: false },
    pageSize: { type: Number, default: config.pageSize },
    pageSizes: { type: Array, default: config.pageSizes },
    rowKey: { type: String, default: "" },
    summaryMethod: { type: Function, default: null },
    column: { type: Object, default: () => { } },
    remoteSort: { type: Boolean, default: true },
    remoteFilter: { type: Boolean, default: false },
    remoteSummary: { type: Boolean, default: false },
    isShowIndex: { type: Boolean, default: false },
    isSelection: { type: Boolean, default: false },
    hidePagination: { type: Boolean, default: false },
    hideDo: { type: Boolean, default: false },
    hideRefresh: { type: Boolean, default: false },
    hideSetting: { type: Boolean, default: false },
    paginationLayout: { type: String, default: config.paginationLayout },
    dataFormat: { type: Function, default: () => { } }
  },
  watch: {
    //监nfromprops里拿到值了
    data() {
      this.tableData = this.data;
      this.total = this.tableData.length;
    },
    apiObj() {
      this.tableParams = this.params;
      this.refresh();
    },
    column: {
      handler() {
        this.userColumn = this.column;
      },
      deep: true
    },
  },
  computed: {
    ismobile() {
      return this.$store.state.global.ismobile
    },
    _height() {
      return Number(this.height) ? Number(this.height) + 'px' : this.height
    },
    _table_height() {
      return this.hidePagination && this.hideDo ? "100%" : "calc(100% - 50px)"
    }
  },
  data() {
    return {
      scPageSize: this.pageSize,
      isActivat: true,
      emptyText: "暂无数据",
      toggleIndex: 0,
      tableData: [],
      total: 0,
      currentPage: 1,
      prop: null,
      order: null,
      loading: false,
      tableHeight: '100%',
      tableParams: this.params,
      userColumn: [],
      customColumnShow: false,
      summary: {},
      config: {
        size: this.size,
        border: this.border,
        stripe: this.stripe
      }
    }
  },
  mounted() {
    //判断是否开启自定义列
    if (this.column) {
      this.getCustomColumn()
    } else {
      this.userColumn = this.column
    }
    // 获取自定义配置
    this.getCustomConfig()
    //判断是否静态数据
    if (this.apiObj && this.apiObj.url) {
      this.getData();
    } else if (this.data) {
      this.tableData = this.data;
      this.total = this.tableData.length
    }
  },
  activated() {
    if (!this.isActivat) {
      this.$refs.scTable.doLayout()
    }
  },
  deactivated() {
    this.isActivat = false;
  },
  methods: {
    columnFormat(row, column, method) {
      if (typeof method === 'string') {
        return method;
      } else if (typeof method === 'function') {
        return method(row, column);
      }
      return row[column.property];
    },
    //获取列
    async getCustomColumn() {
      const userColumn = await config.columnSettingGet(this.tableName, this.column)
      if (userColumn.length > 0) {
        this.userColumn = userColumn
      }
    },
    // 获取配置
    async getCustomConfig() {
      const userConfig = await config.configSettingGet(this.tableName, this.config)
      this.config = userConfig
    },
    //获取数据
    async getData() {
      this.loading = true;
      var reqData = {
        [config.request.page]: this.currentPage,
        [config.request.pageSize]: this.scPageSize,
        [config.request.prop]: this.prop,
        [config.request.order]: this.order
      }
      this.tableParams.page = this.currentPage
      this.tableParams.pageSize = this.scPageSize
      if (this.hidePagination) {
        delete reqData[config.request.page]
        delete reqData[config.request.pageSize]
      }
      Object.assign(reqData, this.tableParams)

      try {
        var res = await this.apiObj.get(reqData);
      } catch (error) {
        this.loading = false;
        this.emptyText = error && error.statusText || "";
        return false;
      }
      try {
        var response = config.parseData(res);
      } catch (error) {
        this.loading = false;
        this.emptyText = "数据格式错误";
        return false;
      }
      if (response.code != config.successCode) {
        this.loading = false;
        this.emptyText = response.msg;
      } else {
        this.emptyText = "暂无数据";
        if (this.hidePagination) {
          this.tableData = response.data || [];
        } else {
          this.tableData = response.rows || [];
        }
        this.total = response.total || 0;
        this.summary = response.summary || {};
        this.loading = false;
      }
      this.$refs?.scTable?.setScrollTop(0)
      this.$emit('dataChange', res, this.tableData)
    },
    //分页点击
    paginationChange() {
      this.getData();
    },
    //条数变化
    pageSizeChange(size) {
      this.scPageSize = size
      this.getData();
    },
    //刷新数据
    refresh() {
      this.$refs.scTable.clearSelection();
      this.getData();
    },
    //更新数据 合并上一次params
    upData(params, page = 1) {
      if (params.page) {
        page = params.page
      }
      this.currentPage = page;
      this.$refs.scTable.clearSelection();
      Object.assign(this.tableParams, params || {})
      if (params.pageSize) {
        this.scPageSize = params.pageSize
      }
      this.getData()
    },
    //重载数据 替换params
    reload(params, page = 1) {
      this.currentPage = page;
      this.tableParams = params || {}
      this.$refs.scTable.clearSelection();
      this.$refs.scTable.clearSort()
      this.$refs.scTable.clearFilter()
      this.getData()
    },
    /**
     * 处理列设置变化事件
     * @param {Array} userColumn - 用户修改后的列配置
     * @description 合并原始列配置的自定义属性(formatter/client/template等)
     */
    columnSettingChange(userColumn) {
      // 合并原始列配置的自定义属性
      const mergedColumns = this.column
        .map(col => {
          const newCol = userColumn.find(item => item.prop === col.prop);
          if (!newCol) return null;

          // 只保留用户修改的基本属性，其他属性从原始配置继承
          return {
            ...newCol,
            formatter: col.formatter,
            client: col.client,
            template: col.template,
            className: col.className,
            showOverflowTooltip: col.showOverflowTooltip,
            customSlot: col.customSlot
          };
        })
        .filter(Boolean);

      this.userColumn = mergedColumns;
      this.toggleIndex += 1;
    },
    //自定义列保存
    async columnSettingSave(userColumn) {
      // console.log(userColumn)
      this.$refs.columnSetting.isSave = true
      try {
        await this.columnSettingSaveIng(userColumn)
      } catch (error) {
        this.$message.error('保存失败')
        this.$refs.columnSetting.isSave = false
      }
      this.$message.success('保存成功')
      this.$refs.columnSetting.isSave = false
    },
    async columnSettingSaveIng(userColumn) {
      await config.columnSettingSave(this.tableName, userColumn)
    },
    //自定义列重置
    async columnSettingBack() {
      this.$refs.columnSetting.isSave = true
      try {
        const column = await config.columnSettingReset(this.tableName, this.column)
        this.userColumn = column
        this.$refs.columnSetting.usercolumn = JSON.parse(JSON.stringify(this.userColumn || []))
      } catch (error) {
        this.$message.error('重置失败')
        this.$refs.columnSetting.isSave = false
      }
      this.$refs.columnSetting.isSave = false
    },
    // 辅助方法，用于获取模板属性值
    getTemplateAttrValue(template, attrName, row) {
      if (template.attr && typeof template.attr[attrName] === 'function') {
        return template.attr[attrName](row);
      } else if (template.function && typeof template.function === 'function') {
        return template.function(row)?.[attrName];
      }
      return template.attr?.[attrName];
    },
    //排序事件
    sortChange(obj) {
      if (!this.remoteSort) {
        return false
      }
      if (obj.column && obj.prop) {
        this.prop = obj.prop
        this.order = obj.order
      } else {
        this.prop = null
        this.order = null
      }
      this.getData()
    },
    //本地过滤
    filterHandler(value, row, column) {
      const property = column.property;
      return row[property] === value;
    },
    //过滤事件
    filterChange(filters) {
      if (!this.remoteFilter) {
        return false
      }
      Object.keys(filters).forEach(key => {
        filters[key] = filters[key].join(',')
      })
      this.upData(filters)
    },
    //远程合计行处理
    remoteSummaryMethod(param) {
      const { columns } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = this.summary[column.property]
        if (values) {
          sums[index] = values
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    configSizeChange() {
      this.$refs.scTable.doLayout()
      this.configChange()
    },
    configChange() {
      config.configSettingSave(this.tableName, this.config)
    },
    //插入行 unshiftRow
    unshiftRow(row) {
      this.tableData.unshift(row)
    },
    //插入行 pushRow
    pushRow(row) {
      this.tableData.push(row)
    },
    //根据key覆盖数据
    updateKey(row, rowKey = this.rowKey) {
      this.tableData.filter(item => item[rowKey] === row[rowKey]).forEach(item => {
        Object.assign(item, row)
      })
    },
    //根据index覆盖数据
    updateIndex(row, index) {
      Object.assign(this.tableData[index], row)
    },
    //根据index删除
    removeIndex(index) {
      this.tableData.splice(index, 1)
    },
    //根据index批量删除
    removeIndexes(indexes = []) {
      indexes.forEach(index => {
        this.tableData.splice(index, 1)
      })
    },
    //根据key删除
    removeKey(key, rowKey = this.rowKey) {
      this.tableData.splice(this.tableData.findIndex(item => item[rowKey] === key), 1)
    },
    //根据keys批量删除
    removeKeys(keys = [], rowKey = this.rowKey) {
      keys.forEach(key => {
        this.tableData.splice(this.tableData.findIndex(item => item[rowKey] === key), 1)
      })
    },
    // 单元格点击
    handleClientClick(column, row) {
      if (column.client && typeof column.client === 'function') {
        column.client(row);
      }
    },
    //原生方法转发
    clearSelection() {
      this.$refs.scTable.clearSelection()
    },
    toggleRowSelection(row, selected) {
      this.$refs.scTable.toggleRowSelection(row, selected)
    },
    toggleAllSelection() {
      this.$refs.scTable.toggleAllSelection()
    },
    toggleRowExpansion(row, expanded) {
      this.$refs.scTable.toggleRowExpansion(row, expanded)
    },
    setCurrentRow(row) {
      this.$refs.scTable.setCurrentRow(row)
    },
    clearSort() {
      this.$refs.scTable.clearSort()
    },
    clearFilter(columnKey) {
      this.$refs.scTable.clearFilter(columnKey)
    },
    doLayout() {
      this.$refs.scTable.doLayout()
    },
    sort(prop, order) {
      this.$refs.scTable.sort(prop, order)
    }
  }
}
</script>

<style lang="scss" scoped>
.scTable-table {
  height: calc(100% - 50px);
}

.client-cell {
  cursor: pointer;
  color: var(--el-color-primary);
  transition: color 0.3s;

  &:hover {
    color: var(--el-color-primary-light-3);
    text-decoration: underline;
  }

  &:active {
    color: var(--el-color-primary-dark-2);
  }
}

.scTable-page {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
}

.scTable-do {
  white-space: nowrap;
}

.scTable:deep(.el-table__footer) .cell {
  font-weight: bold;
}

.scTable:deep(.el-table__body-wrapper) .el-scrollbar__bar.is-horizontal {
  height: 12px;
  border-radius: 12px;
}

.scTable:deep(.el-table__body-wrapper) .el-scrollbar__bar.is-vertical {
  width: 12px;
  border-radius: 12px;
}
</style>
